import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-513d40d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "news" }, "new", -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "ant-menu-title-content ml10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "news" }, "new", -1))
const _hoisted_6 = { key: 1 }

interface Props {
  list: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'menus',
  props: {
    list: {}
  },
  setup(__props: any) {


const openUrl = url => window.open(url)

return (_ctx: any,_cache: any) => {
  const _component_menus = _resolveComponent("menus", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (menu) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: menu.key
    }, [
      (menu.children?.length)
        ? (_openBlock(), _createBlock(_component_a_sub_menu, {
            key: menu.key
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_menus, {
                list: menu.children
              }, null, 8, ["list"])
            ]),
            _: 2
          }, [
            (menu.meta?.icon)
              ? {
                  name: "icon",
                  fn: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(menu.meta.icon)))
                  ]),
                  key: "0"
                }
              : undefined,
            (menu.meta?.new)
              ? {
                  name: "title",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menu.label) + " ", 1),
                    _hoisted_1
                  ]),
                  key: "1"
                }
              : {
                  name: "title",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menu.label), 1)
                  ]),
                  key: "2"
                }
          ]), 1024))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (menu.target)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "ant-menu-item",
                  style: {"padding-left":"24px"},
                  onClick: ($event: any) => (openUrl(menu.target))
                }, [
                  (menu.meta?.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(menu.meta.icon), { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(menu.label), 1)
                ], 8, _hoisted_2))
              : (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: menu.key
                }, _createSlots({
                  default: _withCtx(() => [
                    (menu.meta?.new)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createTextVNode(_toDisplayString(menu.label) + " ", 1),
                          _hoisted_5
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(menu.label), 1))
                  ]),
                  _: 2
                }, [
                  (menu.meta?.icon)
                    ? {
                        name: "icon",
                        fn: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(menu.meta.icon)))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024))
          ], 64))
    ], 64))
  }), 128))
}
}

})